export class SearchPortfolio {
  idOffice: number
  idBranch: number
  idPolicy: number
  idAnnexed: number
  debtorName: string
  letterNumber: number
  idDebtor: number
  onlyActivePortfolio: boolean = false;
  idPortfolio: number;
  //para la resuesta
  stateNamePortfolio: string;
  totalValue: number;
  portfolioBalance: number;
}
